import { Controller } from '@hotwired/stimulus'
export default class extends Controller {
  connect () {
    const ancestor = document.querySelector('.savanna-ascension > .image')
    setTimeout(function () {
      if (ancestor) ancestor.remove()
    }, 3500)
  }
}
